import { useRef, useState } from 'react'

import { useTranslations } from 'next-intl'

import { Loading } from '@/components/Loading/Loading'
import { AddToCartType } from '@/constants'

interface ProductButtonType {
  type: string
  isProcessing?: boolean
  text?: string
  className?: string
  onClick: () => void
  isPreOrderButton?: boolean
  date?: number
}

export const ProductButton = ({
  type,
  className = '',
  text = '',
  onClick,
  isProcessing,
  isPreOrderButton = false,
  date,
}: ProductButtonType) => {
  const buttonRef = useRef(null)
  const [id, setId] = useState('')
  const t = useTranslations('ProductDetail')

  const renderBtn = (e: string) => {
    switch (e) {
      case 'add-to-cart':
        return {
          primary: t('addToCart'),
          second: t('addToCartDesc'),
          styleBtn: 'border border-red-500',
          stylePrimary: 'text-primary-base',
          styleSecond: 'text-primary-base',
        }
      case 'contact':
        return {
          primary: 'Gọi lại cho tôi',
          second: 'Chúng tôi sẽ liên hệ lại bạn ngay',
          styleBtn: 'border border-red-500',
          stylePrimary: 'text-primary-base',
          styleSecond: 'text-primary-base',
        }
      case 'outOfBusiness':
        return {
          primary: 'Ngừng kinh doanh',
          second: '',
          styleBtn: 'border border-dark-400/50 pointer-events-none',
          stylePrimary: 'text-dark-400/50',
          styleSecond: 'text-grey',
        }
      case 'buy-now':
        return {
          primary: t('buyNow'),
          second: t('buyNowDesc'),
          styleBtn: 'bg-primary-base border border-red-500',
          stylePrimary: 'text-white-400',
          styleSecond: 'text-white-400',
        }
      case AddToCartType.PRE_ORDER:
        return {
          primary: 'Đặt trước',
          second: 'Giao hàng sau ',
          subSecond: ' ngày',
          styleBtn: 'bg-primary-base border border-red-500',
          stylePrimary: 'text-white-400',
          styleSecond: 'text-white-400',
        }
      case 'installment':
        return {
          primary: t('installment'),
          second: t('installmentDesc'),
          styleBtn: 'bg-blue border-blue',
          stylePrimary: 'text-white-400',
          styleSecond: 'text-white-400',
        }
      case 'pay-late':
        return {
          primary: t('payLater'),
          second: t('payLaterDesc'),
          styleBtn: 'bg-blue border-blue',
          stylePrimary: 'text-white-400',
          styleSecond: 'text-white-400',
        }

      default:
        return {
          primary: '',
          second: '',
          styleBtn: '',
          stylePrimary: '',
          styleSecond: '',
        }
    }
  }

  
return (
    <button
      type='button'
      ref={buttonRef}
      id={type}
      onClick={ev => {
        setId(ev.currentTarget.id)
        onClick()
      }}
      disabled={isProcessing && id === type}
      className={`${className} ${
        renderBtn(type)?.styleBtn
      } border-black text-black flex h-[64px] w-full flex-wrap content-center items-center justify-center gap-0 rounded border text-mainBody`}
    >
      <span
        className={`${
          renderBtn(type)?.stylePrimary
        } w-ful mb-[4px] block text-[20px] font-bold uppercase leading-[20px]`}
      >
        {isProcessing && id === type ? <Loading /> : renderBtn(type)?.primary}
      </span>

      <>
        {isPreOrderButton ? (
          <span
            className={`${
              renderBtn(type)?.styleSecond
            } block w-full text-mainBody`}
          >
            {text
              ? text
              : renderBtn(type)?.second + date + renderBtn(type)?.subSecond}
          </span>
        ) : (
          <span
            className={`${
              renderBtn(type)?.styleSecond
            } block w-full text-mainBody`}
          >
            {text ? text : renderBtn(type)?.second}
          </span>
        )}
      </>
    </button>
  )
}

export default ProductButton
